import AWS from "aws-sdk";
import { config } from "../aws.config";
const spacesEndpoint = new AWS.Endpoint(config.end_point);
const S3 = new AWS.S3({
  endpoint: spacesEndpoint,
  accessKeyId: config.accessKeyId,
  secretAccessKey: config.secretAccessKey,
});
export default S3;
